export const PAGE_TYPES = [
  { value: 'home', label: 'Home' },
  { value: 'tournament_list', label: 'Tournaments List' },
  { value: 'tournament_detail', label: 'Tournament Detail' },
  { value: 'player_list', label: 'Players List' },
  { value: 'player_detail', label: 'Player Detail' },
  { value: 'scores', label: 'Scores' },
  { value: 'rankings', label: 'Rankings' },
] as const

export type PageTypeValue = typeof PAGE_TYPES[number]['value']

export const getPageTypeLabel = (pageType: string | null): string => {
  if (!pageType) return 'All Pages'
  const found = PAGE_TYPES.find(pt => pt.value === pageType)
  return found ? found.label : pageType.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}
